import styled from 'styled-components';

interface IStatus {
  color: string;
}

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContainerStatus = styled.div<IStatus>`
  display: flex;
  background: ${(props) => props.color};
  font-weight: 600;
  color: #fff;
  padding: 2px;
  margin-left: 4px;
  border-radius: 6px;
  justify-content: center;
`;
